import { Component, Inject, OnInit, Optional } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { OnboardingService } from "src/app/features/onboarding/onboarding.service";
import { MyTicketsComponent } from "src/app/shared/cinejoy/common/my-tickets/my-tickets.component";

@Component({
    selector: 'app-stripe-purchase-popup',
    templateUrl: './stripe-confirmation-popup.component.html',
    styleUrls: ['./stripe-confirmation-popup.component.css'],
  })
  export class StripeConfirmationPopupComponent implements OnInit {
    paymentUrl!:string;
    invalidUsers!:any[];
    finalTicketPrice:number;
    modalData:any;
    subscriptions!:any;
    constructor(
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<StripeConfirmationPopupComponent>,
        private modalService: NgbModal,
        private router: Router,
        private onboardingService: OnboardingService,

    ){}
    
    ngOnInit(): void {
        // this.finalTicketPrice= (this.data.emptyTicketCount+1+this.data.guestUsers)*this.data.ticketPrice;
        // console.log(this.data.emptyTicketCount,"empty",this.data.guestUsers,this.data.ticketPrice);
        this.modalData=this.data;
        this.subscriptions=this.data.subscription;
        console.log(this.data,this.finalTicketPrice, "confirmation data");
        
        this.invalidUsers= this.data.invalidUsers;
        this.paymentUrl=this.data.paymentUrl;
        console.log(this.paymentUrl, "url to proceed")
    }

    closeModal(){
        this.dialogRef.close();
    }

    proceedPayment(){
       window.location.href = this.paymentUrl;
       this.dialogRef.close();
    }
    logoutUser() {
       this.dialogRef.close();
      }
    
      openMyTicket(): void {
        this.closeModal();
        this.router.navigate(['/cinejoy/premiere/lineup']);
        const modalRef = this.modalService.open(MyTicketsComponent, { size: 'lg', backdrop: 'static' });
        
      }
  }